(function() {
'use strict';

angular.module('TR')
    .controller('SelectedParking', SelectedParking);

function SelectedParking(tripService, $routeParams, modalService, basketStore) {
    const sp = this;

    tripService.getTrip($routeParams.tripId).then(trip => {
        const parkingReq = trip && trip.ParkingRequest;

        if (parkingReq) {
            sp.airport = parkingReq.Airport.ShortTitle;
            sp.dropOffDate = parkingReq.DepartureDate;
            sp.pickUpDate = parkingReq.ReturnDate;
        }

        basketStore.parking(trip.BasketId).then(result => {
            sp.Details = result.Details;
        });
    });

    sp.showDetails = function() {
        modalService.launch('partials/popups/parkingdetails', {
            details: sp.Details,
            airport: sp.airport,
            dropOffDate: sp.dropOffDate,
            pickUpDate: sp.pickUpDate
        });
    };
}
})();
